// extracted by mini-css-extract-plugin
export default {"container":"styles_container__o2g5+","content":"styles_content__iG1od","label":"styles_label__Eve8K"};